"use client";

import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CustomCareConsultation() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="72214" id="不確定自己是否符合資格" className="dark bg-background text-foreground py-20 px-4 md:px-10 overflow-hidden">
      <div ref={ref} className={`max-w-7xl mx-auto bg-secondary rounded-[32px] p-8 md:p-12 lg:p-16 flex flex-col md:flex-row items-center justify-between gap-10 shadow-2xl transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="flex-1 text-center md:text-left">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-secondary-foreground mb-4 tracking-tight">
            不確定自己是否符合資格？
          </h2>
          <p className="text-lg md:text-xl text-secondary-foreground/90 max-w-2xl mx-auto md:mx-0 leading-relaxed">
            我們的專業顧問為您提供免費的補助資格評估與居家環境檢測，協助您輕鬆申請政府補助，實現居家醫療精品化。
          </p>
        </div>
        <div className="shrink-0">
          <Button size="lg" asChild className="bg-primary text-primary-foreground hover:bg-primary/90 hover:shadow-[0_0_20px_rgba(220,38,38,0.5)] rounded-full px-10 py-7 text-2xl font-bold font-sans shadow-xl transition-all duration-300 hover:scale-105">
            <Link to="https://interton.com.tw/聯絡我們/">
              聯絡我們
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}